var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8198 12.1016H16.18C15.6444 12.1016 15.1141 12.207 14.6192 12.412C14.1244 12.6169 13.6748 12.9174 13.2961 13.2961C12.9174 13.6748 12.6169 14.1244 12.412 14.6192C12.207 15.1141 12.1016 15.6444 12.1016 16.18V25.8198C12.1016 26.9015 12.5313 27.9388 13.2961 28.7037C13.6748 29.0824 14.1244 29.3828 14.6192 29.5878C15.1141 29.7927 15.6444 29.8982 16.18 29.8982H25.8198C26.9015 29.8982 27.9388 29.4685 28.7036 28.7037C29.4685 27.9388 29.8982 26.9015 29.8982 25.8198V16.18C29.8982 15.6444 29.7927 15.1141 29.5877 14.6193C29.3828 14.1244 29.0824 13.6748 28.7037 13.2961C28.325 12.9174 27.8754 12.617 27.3805 12.412C26.8857 12.2071 26.3554 12.1016 25.8198 12.1016ZM20.9999 26.6101C19.8903 26.6101 18.8056 26.2811 17.883 25.6646C16.9605 25.0482 16.2414 24.172 15.8168 23.1468C15.3921 22.1217 15.281 20.9937 15.4975 19.9054C15.714 18.8171 16.2483 17.8175 17.0329 17.0329C17.8175 16.2483 18.8171 15.714 19.9054 15.4975C20.9937 15.281 22.1217 15.3921 23.1468 15.8168C24.172 16.2414 25.0482 16.9605 25.6646 17.883C26.2811 18.8056 26.6101 19.8903 26.6101 20.9999C26.6101 21.7366 26.465 22.4662 26.1831 23.1468C25.9011 23.8275 25.4879 24.446 24.9669 24.9669C24.446 25.4879 23.8275 25.9011 23.1468 26.1831C22.4662 26.465 21.7366 26.6101 20.9999 26.6101ZM26.844 16.5358C26.58 16.5358 26.3219 16.4575 26.1024 16.3109C25.8829 16.1642 25.7118 15.9558 25.6108 15.7119C25.5097 15.468 25.4833 15.1996 25.5348 14.9407C25.5863 14.6818 25.7134 14.4439 25.9001 14.2573C26.0867 14.0706 26.3246 13.9435 26.5835 13.892C26.8424 13.8404 27.1108 13.8669 27.3547 13.9679C27.5985 14.0689 27.807 14.24 27.9537 14.4595C28.1003 14.679 28.1786 14.937 28.1786 15.201C28.1786 15.555 28.038 15.8945 27.7877 16.1448C27.5374 16.3951 27.198 16.5357 26.844 16.5358Z",
    fill: "url(#paint0_linear_105_34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 17.3535C20.279 17.3535 19.5739 17.5674 18.9742 17.9681C18.3745 18.3688 17.9071 18.9383 17.6311 19.6047C17.3551 20.271 17.2829 21.0043 17.4236 21.7116C17.5643 22.419 17.9116 23.0688 18.4216 23.5788C18.9316 24.0888 19.5814 24.4361 20.2888 24.5768C20.9962 24.7176 21.7294 24.6453 22.3957 24.3693C23.0621 24.0933 23.6316 23.6259 24.0323 23.0262C24.433 22.4265 24.6469 21.7215 24.6469 21.0002C24.6469 20.0331 24.2627 19.1055 23.5788 18.4216C22.8949 17.7377 21.9674 17.3535 21.0002 17.3535Z",
    fill: "url(#paint1_linear_105_34)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 0C9.40201 0 0 9.40201 0 21C0 32.598 9.40201 42 21 42C32.598 42 42 32.598 42 21C42 9.40201 32.598 0 21 0ZM31.9375 25.6348C31.9374 27.3063 31.2734 28.9094 30.0914 30.0914C28.9094 31.2734 27.3063 31.9374 25.6348 31.9375H16.3652C14.6937 31.9374 13.0906 31.2734 11.9086 30.0914C10.7266 28.9094 10.0625 27.3063 10.0624 25.6348V16.3652C10.0625 14.6937 10.7266 13.0906 11.9086 11.9086C13.0906 10.7266 14.6937 10.0626 16.3652 10.0625H25.6348C27.3063 10.0626 28.9094 10.7266 30.0914 11.9086C31.2734 13.0906 31.9374 14.6937 31.9375 16.3652V25.6348Z",
    fill: "url(#paint2_linear_105_34)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_105_34",
    x1: 0.656152,
    y1: 41.3437,
    x2: 41.5344,
    y2: 0.465428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FF6341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#CD39A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_105_34",
    x1: 0.656469,
    y1: 41.344,
    x2: 41.5347,
    y2: 0.465747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FF6341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#CD39A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_105_34",
    x1: 0.65625,
    y1: 41.3437,
    x2: 41.5345,
    y2: 0.465528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCB52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.318,
    stopColor: "#FF6341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.658,
    stopColor: "#CD39A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515BCA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramNew);
export default __webpack_public_path__ + "static/media/instagram New.e7ba18eefcb586a120b1878224b36555.svg";
export { ForwardRef as ReactComponent };